import { InputWithLabel, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import useInputWithTextArea from './hooks/useInputWithTextArea/useInputWithTextArea'
import * as Styles from './styles'

const InputWithTextarea = ({
  inputPlaceholder,
  inputValue,
  textareaPlaceholder,
  textareaValue,
  onChangeInput,
  onChangeTextarea,
  hideInput = false,
  onFocus,
  useHtmlInTextArea = true,
}) => {
  const { handleChangeInput, handleChangeTextarea } = useInputWithTextArea({
    onChangeInput,
    onChangeTextarea,
    useHtmlInTextArea,
  })

  return (
    <Styles.Container>
      {!hideInput && (
        <InputWithLabel
          placeholder={inputPlaceholder}
          value={inputValue}
          fullWidth
          onChange={handleChangeInput}
          onFocus={onFocus}
          maxLength={50}
          backgroundColor="white"
        />
      )}
      <TextAreaRichEditor
        placeholder={textareaPlaceholder}
        onChange={handleChangeTextarea}
        onFocus={onFocus}
        value={textareaValue}
        maxLength={300}
        backgroundColor="white"
        richEditorTheme="bubble"
        minRows={15}
        richEditorToolbarModules={['bold', 'italic', 'link']}
        minHeight="58px"
        textType="html"
      />
    </Styles.Container>
  )
}

export default InputWithTextarea
